import React, { Component } from "react";
import { observer } from "mobx-react";
import { comma } from "../../../../../utils/Utils";
import {
    fn_change_pickup_list, fn_dlv_reload, fn_dlv_research,
    fn_devliery_request, fn_recent_addr
} from "../../../../../function/FnBodyDelivery";
import { fn_payfree_info } from "function/FnBodySetting";

@observer
class DeliveryCallViewExt extends Component {
    constructor(props) {
        super(props);
        this.state = { startNo: 0, deliveryList: [] }
    }

    prev = () => {
        const { rootStore } = this.props;
        if (this.state.startNo > 0) {
            this.setState({
                startNo: this.state.startNo - 1
            })
        }
    }

    next = () => {
        const { rootStore } = this.props;
        if (this.state.startNo < rootStore.deliveryStore.getExpDelivery.length - 3) {
            this.setState({
                startNo: this.state.startNo + 1
            })
        }
    }

    render() {
        const { rootStore } = this.props;
        const deliveryStore = rootStore.deliveryStore;

        let delivery_arr = deliveryStore.getExpDelivery;
        let ynCnt = 0

        rootStore.settingStore.getPayFreeType.useDeliveryResList.filter((element, i) => {
            if (element.useYn == "Y") ynCnt++
        });

        let nullBox;
        switch (deliveryStore.getDeliveryFee.pick_arr_obj.length % 4) {
            case 1:
                nullBox = <><span className="none"></span><span className="none"></span><span className="none"></span></>
                break;
            case 2:
                nullBox = <><span className="none"></span><span className="none"></span></>
                break;
            case 3:
                nullBox = <span className="none"></span>
                break;
            default:
                nullBox = ""
                break;
        }
        let viewData = delivery_arr.slice(this.state.startNo, this.state.startNo + 3)

        let deliveryLiShow = {
            "display": "block",
        }
        let deliveryLiHide = {
            "display": "none",
        }
        let infoData = deliveryStore.getExpDeliverySelect;
        const arr = ['0', '1', '2']

        let statusCk = false
        deliveryStore.getDeliveryFee.pick_arr_obj.map(pick => {
            if (pick.view === true) {
                statusCk = true
            }
        })
        return (
            <>
                {
                    (rootStore.settingStore.getPayFreeType.paymentUseYn === "0" || rootStore.settingStore.getPayFreeType.paymentUseYn === "1")
                        ?
                        <div className="wrap_rider_list_null"> {/*hide*/}
                            <h3>배달대행사 연동하시고 더 편리하게 사용하세요!</h3>
                            <p>배달매니저로 포스에서 바로 배달대행 라이더 요청하세요</p>
                            <button onClick={event => {
                                let link = ""
                                if (rootStore.settingStore.getPayFreeType.paymentUseYn === "0") {
                                    link = "https://delivery.okpos.co.kr/?utm_source=free_month&utm_medium=print&utm_campaign=basic_plan"
                                } else {
                                    link = "https://delivery.okpos.co.kr/?utm_source=kitchen&utm_medium=print&utm_campaign=promo2_plan"
                                }
                                fn_payfree_info(rootStore, link, "mktRiderCall Button")
                            }} >1개월 무료체험 신청하기 <span className="ico"></span></button>
                        </div>
                        :
                        (delivery_arr && delivery_arr.length)
                            ?
                            <div className="wrap_agency">
                                <div className="wrap_rider_list">
                                    <div className="inner">
                                        <ul className="list">
                                            {
                                                (Array.isArray(viewData) && viewData.length > 0) ?
                                                    arr.map((arr, index) => (
                                                        (viewData[arr] != null) ?
                                                            <li key={"deliveryCall_" + index} className={viewData[arr].view} style={viewData[arr].show === true ? deliveryLiShow : deliveryLiHide} >
                                                                <button
                                                                    onClick={event => fn_dlv_research(rootStore, viewData[arr])}
                                                                >
                                                                    <span className="name">{viewData[arr].delivery_name}</span>
                                                                    {
                                                                        (viewData[arr].fee && viewData[arr].fee !== "0") ? <span className="pay">{comma(viewData[arr].fee)}원</span> : ""
                                                                    }
                                                                </button>
                                                            </li>
                                                            :
                                                            <li key={"deliveryCall_" + index}>
                                                                <div className="none"></div>
                                                            </li>
                                                    ))
                                                    :
                                                    <>
                                                        <li key={"deliveryCall_0"}>
                                                            <div className="none"></div>
                                                        </li>
                                                        <li key={"deliveryCall_1"}>
                                                            <div className="none"></div>
                                                        </li>
                                                        <li key={"deliveryCall_2"}>
                                                            <div className="none"></div>
                                                        </li>
                                                    </>
                                            }
                                        </ul>
                                    </div>
                                    <div className="prev">
                                        <button onClick={this.prev}
                                        ><span></span></button>
                                    </div>
                                    <div className="next">
                                        <button onClick={this.next}
                                        ><span></span></button>
                                    </div>
                                </div>
                                <div className="wrap_infomation">
                                    <dl className="list">
                                        <dt>총예치금</dt>
                                        <dd>{comma(infoData.shop_cash)}원
                                            {
                                                (infoData.bank_name && infoData.bank_account) ?
                                                    "(" + infoData.bank_name + " " + infoData.bank_account + ")" : null
                                            }
                                        </dd>
                                    </dl>
                                    <dl className="list">
                                        <dt>총배달비</dt>
                                        <dd>{comma(deliveryStore.getDeliveryFee.delivery_fee)}원
                                            {/*(기본 {comma(deliveryStore.getDeliveryDefaultFee)} + 할증 {deliveryStore.getDeliveryFee.extra_tot})*/}
                                        </dd>
                                    </dl>
                                    <div className="btn">
                                        <button type="button" className="reload"
                                            onClick={event => fn_dlv_reload(rootStore)}
                                        ><span>새로고침</span></button>
                                    </div>
                                </div>
                                <div className="wrap_pickup">
                                    <h3>픽업요청시간 선택</h3>
                                    <div className="radio">
                                        {
                                            (deliveryStore.getDeliveryFee && deliveryStore.getDeliveryFee.pick_arr_obj.length)
                                                ? deliveryStore.getDeliveryFee.pick_arr_obj.map(pick => (
                                                    <label key={pick.time}>
                                                        <input type="radio" name="pickup_time" checked={
                                                            (statusCk === true) ? (pick.view) ? true : "" : (rootStore.settingStore.getPickupDfTime == pick.time) ? true : ""
                                                        }
                                                            //checked={pick.time === rootStore.settingStore.getPickupDfTime ? true : ""}
                                                            onChange={event => fn_change_pickup_list(rootStore, pick.time)}
                                                        />
                                                        {/* <span>{pick.time}분</span> */}
                                                        <span>{(pick.time === "1" ? "즉시" : pick.time + "분")}</span>
                                                    </label>
                                                ))
                                                : null
                                        }
                                        {nullBox}
                                        <button type="button" className="btn"
                                            onClick={event => {
                                                //fn_devliery_request(rootStore)
                                                fn_recent_addr(rootStore)
                                            }}
                                        >배달요청
                                        </button>
                                    </div>
                                    <div className="info">* 배달대행사 계약시 최소요청시간을 협의한 매장은 선택 시간과 다르게 접수될 수 있습니다.
                                        <br /> &nbsp; &nbsp;이용하시는 배달대행사에 문의해주세요</div>
                                </div>
                            </div>
                            :
                            (rootStore.settingStore.getPayFreeType.useDeliveryResList.length > 0 && ynCnt == 0) ?
                                <div className="wrap_rider_list_null"> {/*hide*/}
                                    <h3>배달대행사를 이용하시려면 사용 설정해주세요</h3>
                                    <p className="list">⦁ [설정 &gt; 배달대행사 설정]에서 설정해주세요</p>
                                    <p className="list">⦁ 문의사항은 배달매니저 고객센터(1544-3583)으로 연락주세요</p>
                                </div>
                                :
                                <div className="wrap_rider_list_null"> {/*hide*/}
                                    <h3>등록된 배달대행 업체가 없습니다.</h3>
                                    <p>배달대행사와 계약후, 고객센터(1544-3583)로 연락주세요.</p>
                                </div>
                }
            </>
        );
    }
}

export default DeliveryCallViewExt;